import { Tag } from 'antd';
import StyledTag from './styles/tag.style';

const AtsTag = StyledTag(Tag);

export default AtsTag;
